/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Contract_Phase_Type_InvalidInputs */

const en_clients_validation_contract_phase_type_invalid = /** @type {(inputs: Clients_Validation_Contract_Phase_Type_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract phase is invalid.`)
};

const pt_br2_clients_validation_contract_phase_type_invalid = /** @type {(inputs: Clients_Validation_Contract_Phase_Type_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fase contratual é inválida.`)
};

/**
* | output |
* | --- |
* | "Contract phase is invalid." |
*
* @param {Clients_Validation_Contract_Phase_Type_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_contract_phase_type_invalid = /** @type {((inputs?: Clients_Validation_Contract_Phase_Type_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Contract_Phase_Type_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_contract_phase_type_invalid(inputs)
	return pt_br2_clients_validation_contract_phase_type_invalid(inputs)
});